/* eslint typescript-sort-keys/string-enum: "error" */

export enum FeatureFlag {
  AdvancedExcelExport = 'projects.advanced-excel-export',
  AlignDestructiveFlows = 'guild.align-destructive-flows',
  AlternativeSegmentFeatureFlags = 'core.alternative-segment-feature-flags',
  BudgetRemaining = 'projects.budget-remaining',
  CKEditorUploadResponseJson = 'core.ckeditor-upload-response-json',
  CustomActivityTypes = 'f2f.custom-activity-types',
  DealsIntroductionBlock = 'core.deals-introduction-block',
  EnableFrontendBackOfficeCapabilityBasedAuthorization = 'core.enable-frontend-back-office-capability-based-authorization',
  EnableFrontendCapabilityBasedAuthorization = 'core.enable-frontend-capability-based-authorization',
  EnableReferralCampaign = 'core.enable-referral-campaign',
  ExpensesUsersnap = 'expenses.usersnap',
  InsightsMapChart = 'insights.map-chart',
  InsightsUsersnap = 'insights.usersnap',
  InvoiceRemindersPaymentTermExceeded = 'core.invoice-reminders-payment-term-exceeded',
  InvoicesIntroductionBlock = 'core.invoices-introduction-block',
  InvoicingPeppolVerification = 'invoicing.peppol-verification',
  LegacyProjectPlanningKillSwitch = 'planning.legacy-project-planning-kill-switch',
  MailingIntroductionBlock = 'core.mailing-introduction-block',
  PlanFromEmptyState = 'planning.plan-from-empty-state',
  PlanningUsersnap = 'planning.usersnap',
  ProjectReport = 'projects.download-report',
  ProjectsBulkDnD = 'projects.bulk-drag-drop',
  ProjectsBulkUpdate = 'projects.bulk-update-wbs',
  ProjectsDefaultBillingMethods = 'projects.default-billing-methods',
  ProjectsExcelExport = 'projects.excel-export',
  ProjectsIntroductionBlock = 'core.projects-introduction-block',
  ProjectsMarkUnderlyingWorkAsDoneWhenClosingAProject = 'projects.mark-underlying-work-as-done-when-closing-a-project',
  ProjectsMeetingTooltip = 'projects.meeting-tooltip',
  ProjectsNewOnboarding = 'projects.new-onboarding',
  ProjectsSavedFilters = 'projects.saved-filters',
  ProjectsSwitchTimer = 'projects.switch-timer',
  ProjectsTimeline = 'projects.timeline',
  ProjectsUsersnap = 'projects.usersnap',
  ReactifyAccountDetailPermissions = 'core.reactify-account-detail-permissions',
  ReactifyCallDetailDialog = 'core.reactify-call-detail-dialog',
  ReactifyCallMarkAsDoneDialogs = 'core.reactify-call-mark-as-done-dialogs',
  ReactifyEmailLink = 'core.reactify-email-link',
  ReactifyMeetingMarkAsDoneDialogs = 'core.reactify-meeting-mark-as-done-dialogs',
  ReactifyTaskMarkedAsDoneDialog = 'core.reactify-task-marked-as-done-dialog',
  ReactifyTelephoneLink = 'core.reactify-telephone-link',
  RealUserMonitoringSampleRate = 'core.real-user-monitoring-sample-rate',
  RefactorTLFAdminUserPermissions = 'core.refactor-tlf-admin-user-permissions',
  SettingsTooltips = 'settings.tooltips',
  SimplifiedProjects = 'projects.simplified-projects-2',
  TimesheetsIntroductionBlock = 'core.timesheets-introduction-block',
  TimetrackingTaskFiltering = 'timetracking.task-filtering',
  TwilioVersion = 'core.twilio-js-library-version',
  UsePermissionsInChangeFeaturesDialog = 'core.use-permissions-in-change-features-dialog',
  WorkBreakdownFrontAndCentre = 'projects.work-breakdown-front-and-centre',
}

export enum AccountFeatureFlag {
  AdvanceInvoices = 'projects.advance-invoices',
  ApiAnalyticsUiIntegration = 'connect.api-analytics-ui-integration',
  BackOfficeIntegrations = 'connect.back-office-integrations',
  CostsIntegration = 'costs.integration',
  CustomiseCustomerInformationAndDescription = 'core.customise-customer-information-and-description',
  DashingDashboard = 'core.dashing-dashboard',
  EnableBelgianLateFeeCalculation = 'atlas.atlas-enable-belgian-late-fee-calculation',
  EnableChangeFeaturesDialog = 'signup.enable-signup-trial-feature-personalisation',
  EnableReactifiedUserDetailPage = 'core.enable-reactified-user-detail-page',
  IncomingFinancialDocumentsBookkeepingSend = 'incomingFinancialDocuments.bookkeepingSend',
  IncomingFinancialDocumentsReviewStatus = 'incomingFinancialDocuments.reviewStatus',
  InsightsEnableChartLabels = 'insights.enable-chart-labels',
  InsightsEnableEntityFilterMetadata = 'insights.enable-entity-filter-meta-data',
  InsightsEnablePreviewMode = 'insights.enable-preview-mode',
  InsightsExport = 'insights.export',
  InsightsExportPdf = 'insights.export-pdf',
  InsightsFormattingRules = 'insights.formatting-rules',
  InsightsFormulaFields = 'insights.formula-fields',
  InsightsInternalShare = 'insights.internal-share',
  InsightsSecondLevelGrouping = 'insights.second-level-grouping',
  InsightsSecondLevelGroupingLineChart = 'insights.second-level-grouping-line-chart',
  InsightsToggleChartMeasureColumns = 'insights.toggle-chart-measure-columns',
  InvoiceExport = 'invoicing.invoice-export',
  InvoiceIncludeProductDescription = 'f2f.invoice-include-product-description',
  InvoicingAdvancedModeStrict = 'invoicing.advanced-mode-strict',
  InvoicingPeppolHermesSubmissions = 'invoicing.peppol-hermes-submissions',
  InvoicingPeppolIntegration = 'invoicing.peppol-integration',
  InvoicingPeppolPreferredParticipant = 'invoicing.peppol-preferred-participant',
  InvoicingUblXrechnung = 'invoicing.ubl-xrechnung',
  InvoicingUblXrechnungCreditNote = 'invoicing.ubl-xrechnung-credit-note',
  MultiCurrencyOnSubscription = 'core.multi-currency-on-subscription',
  NextGenProjectsIntegration = 'projects.nextgen-projects-integration',
  OcrIntegration = 'ocr.integration',
  ProjectCloud = 'projects.projectcloud',
  ProjectsCreditNotes = 'projects.credit-notes',
  ProjectsGreenfield = 'projects.greenfield',
  QuotationDefaultExpiryDate = 'core.quotation-default-expiry-date',
  QuotationPreviewExtendedOptions = 'core.quotation-preview-extended-options',
  QuotationPreviewFeature = 'core.quotation-preview-feature',
  ReactifyFileUploadDialog = 'core.reactify-file-upload-dialog',
  RemoveDealNumberFromInvoiceRemarks = 'invoicing.remove-deal-number-from-invoice-remarks',
  RestoreDealPipeline = 'core.restore-deal-pipeline',
  SearableAssigneePicker = 'core.searchable-assignee-picker',
  TimeTrackingReactifiedDialogue = 'timetracking.reactified-dialogue',
  UseCkeditor5 = 'guild.use-ckeditor5',
  UserPreferredCurrency = 'core.user-preferred-currency',
}

export type FeatureFlagValue = boolean | string | null | number;

export interface LegacyFeatureFlagValue {
  id: number;
  value: 'on' | 'off';
  extraInfo: string | null;
}

export const getAll = () => {
  return window.top!.__INITIAL_STATE__.user.featureFlags;
};

export const get = (key: FeatureFlag, defaultValue?: FeatureFlagValue) => {
  const featureFlagValue = window.top!.__INITIAL_STATE__.user.featureFlags[key];
  return typeof featureFlagValue === 'undefined' ? defaultValue : featureFlagValue;
};

export const getAllEnabled = () => {
  const { featureFlags } = window.top!.__INITIAL_STATE__.user;
  return Object.keys(featureFlags).filter((featureFlag) => featureFlags[featureFlag]);
};

export const getAccountFeatureFlag = (key: AccountFeatureFlag, defaultValue?: FeatureFlagValue) => {
  const featureFlagValue = window.top!.__INITIAL_STATE__.account.featureFlags[key];
  return typeof featureFlagValue === 'undefined' ? defaultValue : featureFlagValue;
};
